import React, { Component } from 'react'
import { Icon, Div, P, A } from '@drifthq/tide-core'
import PropTypes from 'prop-types'
import './styles.css'

const FindMyTeamNotification = (onClick) => (
  <P>We recognize your email domain! <A onClick={onClick}>Find your team</A> in Drift</P>
)

const NotificationTextMap = {
  "findMyTeam": FindMyTeamNotification
}

export class DynamicNotification extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    onTrack: PropTypes.func
  }

  componentDidMount() {
    const { onTrack } = this.props
    if (!!onTrack) onTrack()
  }

  render() {
    const { type, onClick } = this.props
    return (
      <Div className="dynamic-notification-container">
        <Div className="notification-icon-container">
          <Icon className="lightning-bolt-blue" name="lightning-bolt-filled"/>
        </Div>
        <Div className="notification-text-container">
          {NotificationTextMap[type](onClick)}
        </Div>
      </Div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DynamicNotification/index.js